module.exports = __webpack_public_path__ + "media/images/number_of_held-fe710b2304aff1595575830565901de7.svg";